import React from "react";
import css from "../assets/css3.svg";
import js from "../assets/javascript.svg";
import react from "../assets/react.svg";
import strapi from "../assets/strapi-icon-svgrepo-com.svg";
import next from "../assets/nextjs-icon-svgrepo-com.svg";
import tailwind from "../assets/tailwindcss.svg";

const data = [
  {
    id: 1,
    img: css,
    des: "User Interface",
    text: "CSS",
  },
  {
    id: 2,
    img: tailwind,
    des: "User Interface",
    text: "Tailwind CSS",
  },
  {
    id: 3,
    img: react,
    des: "Framework",
    text: "React JS",
  },
  {
    id: 4,
    img: js,
    des: "Interaction",
    text: "Java Script",
  },
  {
    id: 5,
    img: next,
    des: "Framework",
    text: "Next JS",
  },
  {
    id: 6,
    img: strapi,
    des: "CMS",
    text: "Strapi",
  },
];

function Skills() {
  return (
    <section id="skills">
      <div className="container">
        <div className="top_section">
          <h5>What Skills I Have</h5>
          <h2>My Skills</h2>
        </div>
        <div className="skills">
          {data.map((skill) => (
            <div className="card-skill">
              <div className="icons">
                <img src={skill.img} alt="" />
              </div>
              <div className="content">
                <h4>{skill.text}</h4>
                <p className="text-light">{skill.des}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
